import EmployeeInfoFamilyComponent from "../components/EmployeeInfoFamily";
import useEmployeeFamily from "../hooks/useEmployeeFamily";

function EmployeeInfoFamily(props) {
  const useEmployeeFamilyProps = useEmployeeFamily();
  return <EmployeeInfoFamilyComponent {...useEmployeeFamilyProps} {...props} />;
}

export default EmployeeInfoFamily;
